import ExcelJS, { Alignment, Borders, Cell, Fill, Font, Workbook } from 'exceljs';

import { DocumentMedicalBillEntity } from '../../../generated-api';
import { ResultPageDocument } from '../defs/types';
import { isPharmacy } from './isPharmacy';
import { medicalBillStatsGrouping } from './medicalBillStatsGrouping';

export function convertToExcelForTatsujin(values: ResultPageDocument<DocumentMedicalBillEntity>[]): Workbook {
  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet('医療費に係る領収書等医療費(医療費通知以外)', {
    views: [{ showGridLines: false }],
  });

  const borderStyle: Partial<Borders> = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };
  const fontStyle: Partial<Font> = {
    name: 'メイリオ',
    size: 9,
    color: { theme: 1 },
  };
  const headerFillStyle: Fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'FFD9D9D9' },
  };
  const headerAlignmentStyle: Partial<Alignment> = { vertical: 'middle', wrapText: true };

  const setBaseStyle = (cell: Cell) => {
    cell.border = borderStyle;
    cell.font = fontStyle;
  };
  const setHeaderStyle = (cell: Cell) => {
    setBaseStyle(cell);
    cell.alignment = headerAlignmentStyle;
  };

  sheet.eachRow((row) => {
    row.height = 15;
  });
  // 中途半端なWidthを指定してる理由は下記URLを参照
  // https://learn.microsoft.com/en-us/previous-versions/office/developer/office-2010/cc802410(v=office.14)?redirectedfrom=MSDN
  const columnWidth = 17.62;

  const headerBusinessCode = sheet.addRow(['事業者コード', '']);
  headerBusinessCode.eachCell(setHeaderStyle);
  headerBusinessCode.getCell(1).fill = headerFillStyle;
  headerBusinessCode.getCell(2).alignment = { ...headerAlignmentStyle, horizontal: 'left' };

  const headerBusinessName = sheet.addRow(['事業者名', '']);
  headerBusinessName.eachCell(setHeaderStyle);
  headerBusinessName.getCell(1).fill = headerFillStyle;
  headerBusinessName.getCell(2).alignment = { ...headerAlignmentStyle, horizontal: 'left' };

  const headerDataName = sheet.addRow(['データ名称', '医療費に係る領収書等医療費(医療費通知以外)']);
  headerDataName.height = 35.75;
  headerDataName.eachCell((cell) => {
    setHeaderStyle(cell);
    cell.fill = headerFillStyle;
  });

  const columnRow = sheet.addRow([
    '医療を受けた方の氏名',
    '病院・薬局などの支払先の名称_上段',
    '病院・薬局などの支払先の名称_下段',
    '医療費の区分_診療_治療_該当区分',
    '医療費の区分_介護保険サービス_該当区分',
    '医療費の区分_医薬品購入_該当区分',
    '医療費の区分_その他の医療費_該当区分',
    '支払った医療費の額',
    '(4)のうち生命保険や社会保険などで補てんされる金額',
  ]);
  columnRow.height = 35.75;
  columnRow.eachCell((cell, number) => {
    setHeaderStyle(cell);
    cell.border = {
      ...borderStyle,
      top: { style: 'double' },
    };
    cell.fill = headerFillStyle;
    sheet.getColumn(number).width = columnWidth;
  });

  const stats = medicalBillStatsGrouping(values.filter((item) => !item.error));

  stats.forEach((value) => {
    const hospitalName = value.hospitalName ?? '';
    const row = sheet.addRow([
      value.patientName ?? '',
      hospitalName,
      '',
      isPharmacy(hospitalName) ? '' : '該当',
      '',
      isPharmacy(hospitalName) ? '該当' : '',
      '',
      value.totalAmount?.toString() ?? '',
      '',
    ]);
    row.eachCell(setBaseStyle);
    row.height = 15;
  });

  return workbook;
}
